import { __decorate, __rest } from "tslib";
import { define, predefine, tools } from '../object-plus/index.js';
import { Transactional } from '../transactions.js';
import { type } from './attrDef.js';
import { createAttributesMixin } from './mixin.js';
import { Record } from './record.js';
export * from './attrDef.js';
export * from './metatypes/index.js';
export { Record };
const { assign, defaults } = tools;
export function attributes(attrDefs) {
    let DefaultRecord = class DefaultRecord extends Record {
    };
    DefaultRecord.attributes = attrDefs;
    DefaultRecord = __decorate([
        define
    ], DefaultRecord);
    return DefaultRecord;
}
Record.onExtend = function (BaseClass) {
    Transactional.onExtend.call(this, BaseClass);
    const Class = this;
    let DefaultCollection = class DefaultCollection extends BaseClass.Collection {
    };
    DefaultCollection.model = Class;
    DefaultCollection = __decorate([
        predefine
    ], DefaultCollection);
    this.DefaultCollection = DefaultCollection;
    if (Class.Collection === BaseClass.Collection) {
        this.Collection = DefaultCollection;
    }
};
Record.onDefine = function (definition, BaseClass) {
    const baseProto = BaseClass.prototype;
    const _a = createAttributesMixin(this.attributes = getAttributes(definition), baseProto._attributes), { properties, _localEvents } = _a, dynamicMixin = __rest(_a, ["properties", "_localEvents"]);
    assign(this.prototype, dynamicMixin);
    definition.properties = defaults(definition.properties || {}, properties);
    definition._localEvents = _localEvents;
    Transactional.onDefine.call(this, definition, BaseClass);
    this.DefaultCollection.define(definition.collection || {});
    this.Collection = definition.Collection;
    this.Collection.prototype.model = this;
    if (definition.endpoint)
        this.Collection.prototype._endpoint = definition.endpoint;
};
function getAttributes({ defaults, attributes, idAttribute }) {
    const definition = attributes || defaults || {};
    if (idAttribute && !(idAttribute in definition)) {
        definition[idAttribute] = void 0;
    }
    return definition;
}
export function auto(proto, attrName) {
    if (typeof Reflect !== 'undefined' && Reflect.getMetadata) {
        if (attrName) {
            type(Reflect.getMetadata("design:type", proto, attrName)).as(proto, attrName);
        }
        else {
            const value = proto;
            return (proto, attrName) => {
                type(Reflect.getMetadata("design:type", proto, attrName)).value(value).as(proto, attrName);
            };
        }
    }
    else {
        proto._log('error', 'Type-R:MissingImport', 'Add import "reflect-metadata"; as the first line of your app.');
    }
}
//# sourceMappingURL=index.js.map